import React  from 'react';
import RAGComponentProto from './rag-proto';

export default function renderBooleanInList(id, props) {
    return <RAGComponentProto renderMode="list" id={id} {...props} />;
}